import { FormConfig, FormFieldType } from "../../../components/form/formTypes";

const topicCategoryFormConfig: FormConfig[] = [
  {
    name: "name",
    label: "topicCategory.field.name",
    placeholder: "topicCategory.field.name",
    type: FormFieldType.Text,
  },
];

export default topicCategoryFormConfig;
